import { convertLexicalJsonToQuery } from '#pplx/frontend/apps/ask/ask-input/query-serialization/lexicalNodeToQuery.js';
import { createQueryPrefillEditorState, createQueryPrefillTextNode, createSkillMention, } from '#pplx/frontend/apps/ask/skills/utils/buildSkillQueryPrefill.js';
import { hasDeepResearchPrefill, isDeepResearchSkillName, } from '#pplx/frontend/ask-models/deepResearchSkill.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { serializedStateToMarkdown } from '#pplx/frontend/composer-sdk/serializedStateToMarkdown.js';
export function isAskDeepResearchInput({ askDeepResearchModel, searchMode, json, }) {
    return (!!askDeepResearchModel &&
        searchMode === SearchMode.ASI &&
        !!json &&
        hasDeepResearchPrefill(convertLexicalJsonToQuery(json.root).prefills));
}
export function prependDeepResearchSkill(value, json, localizedName) {
    if (json && hasDeepResearchPrefill(convertLexicalJsonToQuery(json.root).prefills)) {
        return { value, json };
    }
    const mention = createSkillMention({
        localizedName,
        skillId: 'deep-research',
        skillName: 'deep-research',
    });
    const prefix = [mention.node, createQueryPrefillTextNode(' ')];
    const editorState = json ?? createQueryPrefillEditorState([createQueryPrefillTextNode(value)]);
    const [first, ...rest] = editorState.root.children;
    const children = first?.type === 'paragraph'
        ? [
            { ...first, children: [...prefix, ...first.children] },
            ...rest,
        ]
        : [...createQueryPrefillEditorState(prefix).root.children, ...editorState.root.children];
    return {
        value: `${mention.markdown} ${value}`,
        json: { ...editorState, root: { ...editorState.root, children } },
    };
}
function isDeepResearchMention(node) {
    if (node?.type !== 'mention')
        return false;
    const { props } = node;
    return props.variant === 'skills' && isDeepResearchSkillName(props.text);
}
export function hasDeepResearchMention(node) {
    return (isDeepResearchMention(node) ||
        ('children' in node &&
            Array.isArray(node.children) &&
            node.children.some(hasDeepResearchMention)));
}
function removeDeepResearchMentions(children) {
    return children.flatMap((node, index) => {
        if (isDeepResearchMention(node))
            return [];
        if ('children' in node) {
            const element = node;
            return [{ ...element, children: removeDeepResearchMentions(element.children) }];
        }
        // Remove the mention's inserted separator, preserving the user's remaining whitespace.
        if (node.type === 'text' && isDeepResearchMention(children[index - 1])) {
            const textNode = node;
            if (textNode.text === ' ')
                return [];
            if (textNode.text.startsWith(' '))
                return [{ ...textNode, text: textNode.text.slice(1) }];
        }
        return [node];
    });
}
export function removeDeepResearchSkill(json) {
    const next = {
        ...json,
        root: { ...json.root, children: removeDeepResearchMentions(json.root.children) },
    };
    return { value: serializedStateToMarkdown(next), json: next };
}
//# sourceMappingURL=deepResearchInput.js.map